import React, { useContext } from "react";
import { Box, Center, Text } from "@chakra-ui/react";
import { useTranslation } from 'react-i18next';
import AuthContext from "../contexts/Auth";

export default function RequireSuperuser({ children }) {
  const auth = useContext(AuthContext);
  const isSuperUser = !!auth?.data?.user?.is_superuser;
  const { t } = useTranslation();
  if (!isSuperUser) {
    return (
      <Center><Box><Text color="red.600" fontWeight="bold">{t('common.no_permission')}</Text></Box></Center>
    );
  }
  return children;
}